module.exports = __webpack_public_path__ + "static/media/icw_summary_title_text.352d4e66.png";